import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useAbility } from '../../../contexts/AbilityContext';
import {
  ProfileContainer,
  UserInfo,
  UserName,
  UserEmail,
  ProfileContent,
  UserPosition
} from './styles';
import LogoutIcon from '@mui/icons-material/Logout';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import StopIcon from '@mui/icons-material/Stop';
import { EmployeeAvatar } from '../../../components/common/EmployeeAvatar';
import { Menu, MenuItem, IconButton, Divider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ImpersonationDialog from '../ImpersonationDialog';
import { ACTIONS, SUBJECTS } from '../../../constants/permissions';

const UserProfile = () => {
  const { user, logout, isImpersonating, endImpersonation, impersonationLoading } = useAuth();
  const ability = useAbility();
  const [anchorEl, setAnchorEl] = useState(null);
  const [impersonationDialogOpen, setImpersonationDialogOpen] = useState(false);
  const open = Boolean(anchorEl);

  if (!user) return null;

  // Check if user can impersonate (Admin permissions)
  const canImpersonate = ability.can(ACTIONS.MANAGE, SUBJECTS.IMPERSONATION_SESSION);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      handleClose();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const handleStartImpersonation = () => {
    setImpersonationDialogOpen(true);
    handleClose();
  };

  const handleEndImpersonation = async () => {
    try {
      await endImpersonation();
      handleClose();
    } catch (error) {
      console.error('Failed to end impersonation:', error);
    }
  };

  return (
    <ProfileContainer>
      <ProfileContent onClick={handleClick} style={{ cursor: 'pointer' }}>
        <EmployeeAvatar 
          employee={{ 
            azureId: user.employee.azureId, 
            fullName: user.employee.fullName 
          }} 
          size={32}
        />
        <UserInfo>
          <UserName>{user.employee.fullName}</UserName>
          <UserEmail>{user.employee.email}</UserEmail>
          {user.employee.position && (
            <UserPosition>{user.employee.position.label}</UserPosition>
          )}
        </UserInfo>
        <IconButton 
          size="small" 
          sx={{ 
            padding: 0,
            color: 'inherit'
          }}
        >
          <KeyboardArrowDownIcon fontSize="small" />
        </IconButton>
      </ProfileContent>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {canImpersonate && [
          isImpersonating ? (
            <MenuItem
              key="end-impersonation"
              onClick={handleEndImpersonation}
              disabled={impersonationLoading}
            >
              <StopIcon sx={{ fontSize: 18, marginRight: 1 }} />
              End Impersonation
            </MenuItem>
          ) : (
            <MenuItem key="start-impersonation" onClick={handleStartImpersonation}>
              <TransferWithinAStationIcon sx={{ fontSize: 18, marginRight: 1 }} />
              Start Impersonation
            </MenuItem>
          ),
          <Divider key="divider-1" />
        ]}
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ fontSize: 18, marginRight: 1 }} />
          Logout
        </MenuItem>
      </Menu>
      
      <ImpersonationDialog 
        open={impersonationDialogOpen}
        onClose={() => setImpersonationDialogOpen(false)}
      />
    </ProfileContainer>
  );
};

export default UserProfile; 